import { render, staticRenderFns } from "./forms-container.vue?vue&type=template&id=1bf9a0bd"
import script from "./forms-container.vue?vue&type=script&lang=js"
export * from "./forms-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports